/*
 * Notifications Module
 * Description:
 * Module to display list of notifications in either notifications page or group notifications page
 *
 * Purpose: It is a multi-purpose module that fetches/displays notifications on notifications page
 * or group notifications page. The notification page fetches data using pub/sub pattern while
 * group notifications work on AJAX requests
 * 
 * Inputs
 * - wsHost: Web Socket (ws) Location. Gets the value from .env
 * - ajaxURL: If using AJAX, then it's URL
 * - page: Page number to be used when lazy loading. Default is 1
 * - isNtfPage: Boolean to indicate if page is notifications page
 * - ntfMethod: Method to get the notifications. Default is ws
 * - action: By default, action is to get notification count (getcount). If getdata then gets the data
 * - apiData: Object passed to the server for verification
 * - template: Template used to render the notifications
 * - moreActionsTemplate: Template to display actions that can be taken
 * - elActionMenuId: Container ID of the action menu
 * - elLazyButton: ID of the lazy loading button
 * - isBind: Should the events be binded. Default is true that means bind the events
 * 
 * Output
 * - function that has one accessible method init 
 * - template returns HTML string to be rendered
 *
 * @authors: Chiran Doshi and Elton Jain
 */


define('modules/Notification',['jquery', 'UI', 'JSTemplate', 'Auth', 'Toastr', 'modules/common/Constants', 'Config', 'cookie'], function($, UI, template, Auth, Toastr, Constants, Config) {

    'use strict';

    return function() {
        var defaults = {
                ajaxURL: '/ajax/notifications',
                page: 1,
                isNtfPage: false,
                apiData: {
                    userId: Auth.getUser().id,
                    from: null, // ID of last notification
                    page: 1, // Page number 
                },
                template: 'tplNotificationList',
                moreActionsTemplate: 'tplNotificationActionPopup',
                elActionMenuId: 'ntfPopUpActionMenu',
                elLazyButtonId: 'loadMore',
                isBind: true,
                limitKey: 'notification_limit'
            },

            lastNtfId = 0, // Last Notification ID

            actionList = {
                'kick': {
                    confirm: 'Are you sure to kick out this user?',
                    icon: 'ion-ios-body'
                },
                'warn': {
                    confirm: 'Are you sure to warn this user?',
                    icon: 'ion-alert-circled'
                },
                'ban': {
                    confirm: 'Are you sure to ban this user?',
                    icon: 'ion-android-cancel'
                },
                'delete': {
                    confirm: 'Are you sure?',
                    icon: 'ion-trash-a'
                },
                'accept': {
                    icon: 'ion-ios-checkmark-outline icon-accept',
                    altIcon: 'ion-ios-checkmark icon-accept',
                    greyIcon: 'ion-ios-checkmark-outline icon-greyed'
                },

                'reject': {
                    icon: 'ion-ios-close-outline icon-reject',
                    altIcon: 'ion-ios-close icon-reject',
                    greyIcon: 'ion-ios-close-outline icon-greyed'
                },

                'accepted': {
                    icon: 'ion-ios-checkmark icon-accept'
                },

                'rejected': {
                    icon: 'ion-ios-close icon-reject'
                },

            },

            base = {},

            o,
            $elNtfContainer,
            ntfData = [],
            initialFetch = false,
            selectedLi = null,
            unreadCount = 0,
            langs = Config.get('lang'),

            /**
             * [updateNotificationBubble updates notification bubble count in header and navigation menu]
             *
             * @param  Integer count [new notification count]
             *
             */
            updateNotificationBubble = function(count) {
                document.title = document.title.replace(/ *\([^)]*\) */g, "");
                unreadCount = count;
                var $bubble = UI.$header.find('.ntf-bubble');
                if (count > 0) {
                    $bubble.html(count).removeClass('hidden');
                    document.title = '(' + count + ') ' + document.title;
                } else {
                    $bubble.html('0').addClass('hidden');
                }
            },

            /**
             * Get unread notification count
             */
            getUnreadCount = function() {
                return unreadCount;
            },

            /**
             * [_isPresent checks if data is already present in ntfData]
             */
            _isPresent = function(id) {
                var obj = ntfData.filter(function ( obj ) {
                    return obj.id === id;
                })[0];

                if(obj) {
                    return true;
                } else {
                    return false;
                }
            },

            /**
             * [_renderNtfs renders the notifications]
             *
             * @param  Array data [array of notifications]
             * 
             */
            _renderNtfs = function(data, updates) {
                var html = '',
                    totalLength = data.length;

                if (data.length) {
                    var index = [];
                    $('#' + o.elNtfContainerId + ' .load-more-feed').find('a').removeClass('loading');

                    // For loop to determine which indices already present
                    for(var i = 0;i < data.length;i++) {
                        if(_isPresent(data[i].id)) {
                            index[index.length] = i; 
                        } 
                    }

                    // For loop to remove those elements
                    for (var i = index.length - 1; i >= 0; i--) {
                        data.splice(index[i],1);
                    }

                    ntfData.push.apply(ntfData, data);

                    if(!updates) {
                        lastNtfId = data[data.length - 1].id;    
                    }    
                    
                } else {
                    $('#' + o.elNtfContainerId + ' .load-more-feed').remove();
                }

                html = template(o.template, {
                    data: data,
                    actionList: actionList,
                    props: o,
                    initialFetch: initialFetch
                });

                // If initial data is fetched, then append it to the container
                if (!initialFetch) {
                    $elNtfContainer.removeClass('loading');
                    $elNtfContainer.append(html);
                } else { // Else decide if content is to be prepended or appended 

                    // If prependContent is false, then append else prepend
                    if (updates) {
                        $elNtfContainer.prepend(html);
                    } else {
                        $(html).insertBefore('#' + o.elNtfContainerId + ' li:last-child');
                    }
                }

                if (!initialFetch) {
                    initialFetch = true;
                }

                if(totalLength < Constants.limits[o.limitKey]) {
                    $elNtfContainer.addClass('nomore');
                    $('#' + o.elNtfContainerId + ' .load-more-feed').remove();
                }

                if($('.welcome-to-pt').length > 0) {
                    require(['Helper'], function(Helper) {
                        Helper.linkifyFeedContent($('.welcome-to-pt'));
                    });
                }

                
            },

            _callNotification = function(data) {
                var n = new Notification(data.title, { 
                    body: data.text,
                    icon: data.image,
                    tag: data.event_type
                });

                //var x = document.getElementById("ntfTone"); 
                //x.play();

                n.onclick = function(ev) {
                    window.open(data.target_url);
                    require(['Mixpanel'],function(MixPanel) {
                        MixPanel.hit('click', {
                            'target': 'web notification click'
                        });
                    });
                    n.close();
                }; 
            },

            _openNtfPopup = function(data) {
                var html = template('tplNotificationPopup',{
                        data: JSON.stringify(data),
                        langs: langs
                    });

                UI.$b.append(html);

                require(['History'], function(History) {
                    History.pushState({
                        popupId: 'ntfPermissionPopup',
                        url: window.location.href
                    });    
                });
                

                UI.noscroll(true);
            },

            /**
             * [_fetchNtfByAjax fecthes notification data by ajax]
             *
             */
            _fetchNtfByAjax = function(updates) {
                var before = updates ? 0 : lastNtfId;


                return $.ajax({
                    data: {
                        userId: o.apiData.userId,
                        mark_read: 1,
                        before: before
                    },
                    url: o.ajaxURL,
                    type: 'POST'
                });
            },

            /**
             * [_checkNotification checks if notification exists on the server]
             *
             */
            _checkNotification = function() {
                if(Config.get('page.route') === 'user.notifications') {
                    getData();
                }
            },

            /**
             * [_submitAction submits the request to the server]
             *
             * @param  Object action [contains all parameters that need to be sent to the server]
             * @param  Integer id     [Id of the notification]
             *
             * @return promise        [return JQUERY promise in order to resolve later]
             */
            _submitAction = function(action, id) {
                var badgeIcon,
                    data = {};

                data.notificationId = id;

                $.each(action.parameters, function(key, value) {
                    data[value.key] = value.value;
                });

                return $.ajax({
                    url: action.url,
                    type: 'POST',
                    data: data
                });
            },

            /**
             * [_getIndexAction description]
             *
             * @param  {[type]} actions    [description]
             * @param  {[type]} actionType [description]
             *
             * @return {[type]}            [description]
             */
            _getIndexAction = function(actions, actionType) {
                for (var i = 0; i < actions.length; i++) {
                    if (actionType === actions[i].type) {
                        return i;
                    }
                }
                return -1;
            },

            /**
             * [_bindEvents binds the necessary events to the notification container]
             *
             */
            _bindEvents = function() {
                $elNtfContainer.on('click', '#' + o.elLazyButtonId, function(ev) {
                    ev.preventDefault();
                    $(this).find('a').addClass('loading');
                    getData(false);
                });


                $elNtfContainer.on('click', '.ntf-action', function(ev) {
                    ev.preventDefault();
                });

                UI.$b.on('click', '#ntfEnable', function(ev) {
                    var data = $(this).data('ntf');

                    require(['History'],function(History) {
                        History.popState();
                    });

                    Notification.requestPermission(function(status) {  // status is "granted", if accepted by user
                        if(status === 'granted') {
                            _callNotification(data);   
                        } 
                    });

                    require(['Mixpanel'],function(MixPanel) {
                        MixPanel.hit('click', {
                            'target': 'web notification enable'
                        });
                    });
                });


                UI.$b.on('click', '#ntfDisable', function(ev) {

                    $.cookie("web-ntf-disable", 1, { expires : 1 });

                    require(['History'],function(History) {
                        History.popState();
                    });

                    require(['Mixpanel'],function(MixPanel) {
                        MixPanel.hit('click', {
                            'target': 'web notification disable'
                        });
                    });
                });

                // $elNtfContainer.on('click', '.ntf-action-more, .ntf-actionable', function(ev) {
                //     ev.preventDefault();

                //     var that = $(this),
                //         id = that.data('id'),
                //         index = ntfData.map(function(e) {
                //             return e.id;
                //         }).indexOf(id),
                //         actions = ntfData[index].actions;

                //     selectedLi = that.closest('li');

                //     if (that.hasClass('ntf-action-more')) {
                //         var html = template(o.moreActionsTemplate, {
                //             actions: actions,
                //             id: id,
                //             actionList: actionList
                //         });

                //         UI.$b.append(html);

                //     } else if (that.hasClass('ntf-actionable')) {
                //         var indexAction = _getIndexAction(actions, that.data('action')),
                //             action = actions[indexAction],
                //             badgeIcon;

                //         _submitAction(action, id).done(function(results) {
                //             badgeIcon = that.children('i');

                //             if (action.type === 'accept') {
                //                 badgeIcon.removeClass().addClass(actionList.accepted.icon + ' icon-mid');
                //                 that.siblings().children('i').removeClass('icon-reject').addClass('icon-greyed');
                //             } else if (action.type === 'reject') {
                //                 badgeIcon.removeClass().addClass(actionList.rejected.icon + ' icon-mid');
                //                 that.siblings().children('i').removeClass('icon-accept').addClass('icon-greyed');
                //             }

                //             that.removeClass('ntf-actionable').addClass('ntf-action');
                //             that.siblings().removeClass('ntf-actionable').addClass('ntf-action');
                //         });
                //     }
                // });
                

                // on click show action list popup
                UI.$b.on('click', '#' + o.elActionMenuId + ' li', function(e) {
                    var id = $(this).parent().data('id'),
                        index = ntfData.map(function(e) {
                            return e.id;
                        }).indexOf(id),
                        actionType = $(this).data('action'),
                        action,
                        a;

                        if(actionType === 'cancel') {
                            $('#' + o.elActionMenuId).remove();
                            return;
                        }

                        a = confirm(actionList[actionType].confirm);

                    if (a) {
                        var indexAction = _getIndexAction(ntfData[index].actions, actionType);
                        action = ntfData[index].actions[indexAction];
                        _submitAction(action, id).done(function(results) {
                            $('#' + o.elActionMenuId).remove();

                            selectedLi.slideUp('slow', function() {
                                $(this).remove();
                            });

                            if (results.status) {
                                var toastr = new Toastr({
                                    'message': 'Action has been taken'
                                });
                            }
                        });
                    }
                });
            },

            getData = function(updates) {

                _fetchNtfByAjax(updates).done(function(results) {
                    if(results.status) {
                        var data = results.response.notifications;
                        
                        _renderNtfs(data, updates);    
                    }
                    
                });
            },

            /**
             * [init method is an exposed public method that needs to be called]
             *
             * @param  Object options [parameters with which module is initialized]
             *
             */
            init = function(options) {
                o = $.extend(defaults, options);

                if (!o.elNtfContainerId) {
                    throw ('Notification: Pass arguments correctly');
                }

                // if (options.action === 'getdata') {
                //     $elNtfContainer = $('#' + o.elNtfContainerId);    
                // }
                // 
                $elNtfContainer = $('#' + o.elNtfContainerId);

                o.apiData.action = o.action;
                
                _checkNotification();

                if(o.isBind) {
                    _bindEvents();    
                }

            };

        return {
            init: init,
            getData: getData,
            updateNotificationBubble: updateNotificationBubble,
            getUnreadCount: getUnreadCount
        };
    };
});
